.root {
  --custom-emoji-size: 2rem;

  position: relative;
  min-width: 2rem;
  min-height: 2rem;
  margin-inline-start: 0.25rem;

  &:first-child {
    margin-inline-start: 0;
  }

  :global(.AnimatedSticker) {
    position: absolute;
    top: 0;
    left: 0;
  }
}

.custom {
  opacity: 0;
}

.visible {
  opacity: 1;
}

.custom-animated {
  animation: custom-fade-in 0.2s ease-in-out forwards;
  animation-delay: var(--_animation-delay);
}

.chosen::before {
  content: '';

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;

  background-color: var(--color-background-compact-menu-hover);
}

.static-icon {
  position: absolute;
  top: 5%;
  left: 5%;

  width: 90%;
  height: 90%;
}

.lock {
  position: absolute;
  right: 0;
  bottom: 0;

  padding: 0.125rem;
  border-radius: 50%;

  font-size: 0.875rem;

  background-color: var(--color-background-compact-menu);
}

@keyframes custom-fade-in {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
